import { render, staticRenderFns } from "./curriculumList.vue?vue&type=template&id=0d5e6387&scoped=true&"
import script from "./curriculumList.vue?vue&type=script&lang=js&"
export * from "./curriculumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e6387",
  null
  
)

export default component.exports